import config from '@/config'
import { ConversationType } from '@/models/Conversation'
import { useGlobalStore } from '@/store/app'
import { PaginationParams } from '@/types/PaginationParams'
import { requests } from './HTTPService'

const http = requests(config?.COMMUNITIES_SERVER_URL)

class ConversationsV2ServiceCls {
  get endpoint(): string {
    const appStore = useGlobalStore()
    return `/v2/${appStore.locationId}/conversations`
  }

  async createConversation(
    members: Array<string>,
    type: ConversationType
  ): Promise<any> {
    const response = await http.post(this.endpoint, { members, type })
    return response.data
  }

  async getConversations(query?: any): Promise<any> {
    const response = await http.get(this.endpoint, { params: query })
    return response.data
  }

  async getConversationById(conversationId: string): Promise<any> {
    const response = await http.get(`${this.endpoint}/${conversationId}`)
    return response.data
  }

  async clearConversation(conversationId: string): Promise<any> {
    const response = await http.delete(`${this.endpoint}/${conversationId}`)
    return response.data
  }

  async blockConversation(conversationId: string): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/${conversationId}/block`
    )
    return response.data
  }

  async unblockConversation(conversationId: string): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/${conversationId}/unblock`
    )
    return response.data
  }

  async markConversationAsRead(conversationId: string): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/${conversationId}/read`
    )
    return response.data
  }

  async getConversationSuggestions(query?: any): Promise<any> {
    const response = await http.get(`${this.endpoint}/suggestions`, {
      params: query,
    })
    return response.data
  }

  async getBlockedConversations(query?: any): Promise<any> {
    const response = await http.get(`${this.endpoint}/blocked`, {
      params: query,
    })
    return response.data
  }

  async getConversationHistory(
    conversationId: string,
    paginationParams: PaginationParams
  ): Promise<any> {
    const response = await http.get(
      `${this.endpoint}/${conversationId}/messages`,
      {
        params: { ...paginationParams, sort: paginationParams.pageSort },
      }
    )
    return response.data
  }
}

export const ConversationsV2Service = new ConversationsV2ServiceCls()

export type IConversationsV2Service = ConversationsV2ServiceCls
